import { brandsI18n } from '../../localization'
import { FormBuilder } from '../../modules/formBuilder'
import { LoadingScreen } from '../../modules/loadingScreen'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'

export const scbStateMap = {
  CC_START: {
    Component: LoadingScreen,
    props: {
      subTitle: brandsI18n.t('scb.ccStartSubTitle'),
    },
  },
  CC_SCB_PERSONAL: {
    Component: FormBuilder,
  },
  CC_SCB_ADDRESS_DETAILS: {
    Component: FormBuilder,
  },
  CC_SCB_EMP: {
    Component: FormBuilder,
  },
  CC_SCB_INCOME_DETAILS: {
    Component: FormBuilder,
  },
  CC_SCB_CONFIRMATION: {
    Component: FormBuilder,
  },
  CC_SCB_REVIEW: {
    Component: Review,
  },
  CC_SCB_SUCCESS: {
    Component: StatusScreen,
  },
  CC_SCB_EDIT: {
    Component: StatusScreen,
  },
  CC_SCB_REJECT: {
    Component: StatusScreen,
  },
  CC_SCB_REJECT_DUPLICATE: {
    Component: StatusScreen,
  },
  CC_SCB_ERROR: {
    Component: StatusScreen,
  },
  CC_SCB_INPROGRESS: {
    Component: StatusScreen,
  },
}
